export const FORMATION_LESSONS_PT = [
  {
    id: 'formation-1',
    numero: 1,
    titre: "Compreender a conta de formação CPF",
    sousTitre: "Os seus direitos à formação",
    contexte: "Todo o trabalhador em França tem uma conta de formação pessoal que acumula a cada ano de trabalho. Veja como funciona.",
    explication: [
      "**CPF** (Compte Personnel de Formation): conta pessoal onde acumula crédito de formação — 500€ por ano como trabalhador a tempo inteiro.",
      "**Quem beneficia?** Todo o trabalhador ou desempregado — desde os 16 anos até à reforma.",
      "**O que financia?** Formação profissional, obtenção de diplomas, aulas de condução, aprendizagem de línguas estrangeiras...",
      "**A conta não desaparece**: o saldo mantém-se mesmo após mudar de emprego ou períodos de desemprego.",
      "**Limite máximo**: pode acumular até 5.000€ (8.000€ para trabalhadores com baixas qualificações).",
    ],
    question: "Quanto é adicionado à conta CPF anualmente para um trabalhador a tempo inteiro?",
    options: [
      { id: 'a', text: "500€ por ano", correct: true },
      { id: 'b', text: "1.000€ por ano", correct: false },
      { id: 'c', text: "250€ por mês", correct: false },
    ],
    explication_reponse: "O trabalhador a tempo inteiro acumula 500€ por ano. Para trabalhadores com baixas qualificações (sans qualification): 800€. O saldo acumula e continua a ser seu.",
  },
  {
    id: 'formation-2',
    numero: 2,
    titre: "Utilizar Mon Compte Formation",
    sousTitre: "Passo a passo",
    contexte: "Tem saldo CPF. Como encontrar uma formação adequada e reservá-la directamente online?",
    explication: [
      "**O site oficial**: moncompteformation.gouv.fr — gratuito, sem intermediário. Desconfie de sites intermediários que cobram comissão.",
      "**Criar a conta**: com o número de segurança social e endereço de email. Active-a com o código enviado para o telemóvel.",
      "**Pesquisar formação**: use a barra de pesquisa com palavras-chave — 'Excel', 'anglais', 'informatique'.",
      "**Verificar a acreditação**: confirme que a formação tem acreditações oficiais (Qualiopi, RNCP) antes de reservar.",
      "**Reserva directa**: se o saldo for suficiente, pague directamente com CPF sem tirar dinheiro do bolso.",
    ],
    question: "Onde se inscreve para uma formação financiada pelo CPF?",
    options: [
      { id: 'a', text: "Em moncompteformation.gouv.fr directamente", correct: true },
      { id: 'b', text: "No escritório do Pôle emploi", correct: false },
      { id: 'c', text: "Apenas através do empregador", correct: false },
    ],
    explication_reponse: "moncompteformation.gouv.fr é o único site oficial. Pode pesquisar, reservar e pagar directamente sem intermediário.",
  },
  {
    id: 'formation-3',
    numero: 3,
    titre: "Formação durante o trabalho",
    sousTitre: "Os seus direitos com o empregador",
    contexte: "Quer fazer uma formação mas continua a trabalhar. Quais são as opções?",
    explication: [
      "**Plano de desenvolvimento de competências**: o empregador é obrigado a formá-lo para manter a empregabilidade. Peça-o na entrevista profissional.",
      "**Licença de formação Pro-A**: permite fazer formação mantendo o salário — sujeito à aprovação do empregador.",
      "**Formação fora do horário de trabalho**: pode formar-se à noite ou ao fim de semana com o CPF sem informar o empregador.",
      "**Entrevista profissional de 2 em 2 anos**: o empregador é obrigado a realizá-la. Oportunidade para pedir formação ou progressão.",
      "**Recusa do empregador**: se recusar a formação sem motivo válido, pode apresentar queixa junto da DREETS (Direcção do Trabalho).",
    ],
    question: "Pode fazer formação com CPF sem informar o empregador?",
    options: [
      { id: 'a', text: "Sim, se a formação for fora do horário de trabalho", correct: true },
      { id: 'b', text: "Não, a aprovação do empregador é sempre obrigatória", correct: false },
      { id: 'c', text: "Sim sempre, incluindo durante o horário de trabalho", correct: false },
    ],
    explication_reponse: "A formação fora do horário de trabalho (noite, fim de semana) pode ser financiada pelo CPF sem informar o empregador. A formação durante o trabalho precisa da aprovação.",
  },
  {
    id: 'formation-4',
    numero: 4,
    titre: "Combater a fraude na formação",
    sousTitre: "Proteja o saldo",
    contexte: "A fraude em contas CPF é muito frequente. Como proteger o saldo de roubo?",
    explication: [
      "**A fraude habitual**: telefonema oferecendo uma formação 'gratuita' pedindo o número de segurança social para 'inscrever'.",
      "**Nunca dê o número de segurança social** a alguém que lhe telefona aleatoriamente — mesmo dizendo ser do Pôle emploi.",
      "**Verifique o saldo**: entre regularmente em moncompteformation.gouv.fr para confirmar que o saldo está intacto.",
      "**Se descobrir fraude**: denuncie imediatamente em moncompteformation.gouv.fr → 'signaler une fraude' ou ligue para 0970 24 00 48.",
      "**Regra de ouro**: qualquer oferta de formação 'gratuita que se paga sozinha pelo CPF' por telefone não solicitado é uma fraude.",
    ],
    question: "Uma pessoa telefonou oferecendo formação gratuita e pede o número de segurança social. O que deve fazer?",
    options: [
      { id: 'a', text: "Recusar e desligar — é uma fraude", correct: true },
      { id: 'b', text: "Dar o número se a oferta parecer interessante", correct: false },
      { id: 'c', text: "Pedir mais informações antes de decidir", correct: false },
    ],
    explication_reponse: "Este tipo de telefonemas é sempre uma fraude. Não há ofertas gratuitas no CPF desta forma. Desligue e denuncie para 0970 24 00 48.",
  },
];
